<div *ngIf="!message" style="text-align: center; margin-top: 20px">Completing Single Sign On...</div>
<div *ngIf="message" style="text-align: center; margin-top: 20px">{{message}}</div>
<div *ngIf="napRedirectUrl" style="text-align: center; margin-top: 20px">
    <p>FAMAuth authorization is required to log into WFDSS. Please use the following link to request or recertify access.</p>
    <a [href]="napRedirectUrl" target="_blank" rel="noreferrer noopener">Request access</a>
</div>
